import { Button, Modal } from 'rsuite';
import styles from './ModalNoDetailsProducts.module.scss';

type List = {
  label: string;
  value: string;
};

type ModalNoDetailsProductsProps = {
  show: boolean;
  produtos: List[];
  title: string;
  subtitle: string;
  close: () => void;
};

export const ModalNoDetailsProducts = ({ title, subtitle, show, close, produtos }: ModalNoDetailsProductsProps) => (
  <Modal className={styles['modal-no-details-products']} size="sm" show={show} onHide={close}>
    <Modal.Header className={styles.header}>
      <Modal.Title>{title}</Modal.Title>
      <p className={styles.subtitle}>{subtitle}</p>
    </Modal.Header>
    <Modal.Body className={styles.body}>
      {produtos?.map(item => (
        <p key={item.value}>{item.label}</p>
      ))}
    </Modal.Body>
    <Modal.Footer className={styles.footer}>
      <Button className={styles['close-btn']} onClick={close} appearance="primary">
        FECHAR
      </Button>
    </Modal.Footer>
  </Modal>
);
